import styled from 'styled-components';

export const AvatarBlock = styled.div`
  padding: 0 0 20px;
  display: flex;
  gap: 20px;
  align-items: center;
`;
